import configureStore from './configureStore'

/**
 * use this import to access the store outside of components
 * @example
 * ```
 *      import store from '......store'
 *      const getReduxState = () => store.getState();
 * ```
 * 
 * @note this can't be used with server side rendering because it will give everyone 
 *  who requests the store a shared store!
 */
const store = configureStore()

window.GET_APPLICATION_STORE = (stringify = true) => {
  if (!(store && store.getState && typeof store.getState === 'function')) {
    console.warn('The application store was not available. store:', store)
    return null
  }
  if (stringify) {
    function decycle(obj, stack = []) {
      if (!obj || typeof obj !== 'object') return obj

      if (stack.includes(obj)) return null

      let s = stack.concat([obj])

      return Array.isArray(obj)
        ? obj.map((x) => decycle(x, s))
        : Object.fromEntries(
            Object.entries(obj).map(([k, v]) => [k, decycle(v, s)])
          )
    }
    return JSON.stringify(decycle(store.getState()))
  }
  return store.getState()
}

export default store